import { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button'
import { useTranslation } from 'react-i18next'
import { CONSENT, getConsent, setConsent, onConsentReset } from '../../helpers/consent'
import { enableAnalytics, disableAnalytics } from '../../helpers/analytics'
import { enableMetaPixel, disableMetaPixel } from '../../helpers/meta_pixel'

// GDPR/ePrivacy cookie banner.
//
// Strictly-necessary cookies (the authentication session) are always active and
// are not part of this choice. Analytics (Google Analytics) and marketing (the
// Meta Pixel) are gated: both are enabled *only* if the user clicks "Accept
// toate", and never before.
export const CookieConsentBanner = () => {
  const { t } = useTranslation()
  // Show only while the user has not decided yet.
  const [visible, setVisible] = useState(() => getConsent() === null)

  // Re-appear when the user reopens cookie settings from the footer.
  useEffect(() => onConsentReset(() => setVisible(true)), [])

  if (!visible) return null

  const acceptAll = () => {
    setConsent(CONSENT.GRANTED)
    enableAnalytics()
    enableMetaPixel()
    setVisible(false)
  }

  const rejectNonEssential = () => {
    setConsent(CONSENT.DENIED)
    disableAnalytics()
    disableMetaPixel()
    setVisible(false)
  }

  return (
    <div className="cookie-consent-banner" role="dialog" aria-live="polite" aria-label={t('shared.cookies.ariaLabel')}>
      <div className="cookie-consent-text">
        {t('shared.cookies.text')}{' '}
        {/* TODO: point this to the privacy policy (link to be added later). */}
        <a href="#" className="pretty-link">{t('shared.cookies.privacyPolicy')}</a>.
      </div>
      <div className="cookie-consent-actions">
        <Button variant="link" className="cookie-consent-reject" onClick={rejectNonEssential}>
          {t('shared.cookies.onlyNecessary')}
        </Button>
        <Button className="primary-gradient" onClick={acceptAll}>
          {t('shared.cookies.acceptAll')}
        </Button>
      </div>
    </div>
  )
}
